import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, vShow as _vShow } from "vue";
const _hoisted_1 = {
  class: "page-luma"
};
const _hoisted_2 = {
  class: "prompt-box"
};
const _hoisted_3 = {
  class: "images"
};
const _hoisted_4 = {
  class: "item"
};
const _hoisted_5 = {
  key: 0,
  class: "btn-swap"
};
const _hoisted_6 = {
  class: "prompt-container"
};
const _hoisted_7 = {
  class: "input-container"
};
const _hoisted_8 = {
  key: 0,
  class: "upload-icon"
};
const _hoisted_9 = ["rows"];
const _hoisted_10 = {
  class: "params"
};
const _hoisted_11 = {
  class: "item-group"
};
const _hoisted_12 = {
  class: "item-group"
};
const _hoisted_13 = {
  class: "item-group"
};
const _hoisted_14 = {
  key: 0,
  class: "list-box"
};
const _hoisted_15 = {
  class: "item"
};
const _hoisted_16 = {
  class: "left"
};
const _hoisted_17 = {
  class: "container"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = ["src"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "center"
};
const _hoisted_22 = {
  key: 0,
  class: "failed"
};
const _hoisted_23 = {
  key: 1,
  class: "prompt"
};
const _hoisted_24 = {
  key: 0,
  class: "right"
};
const _hoisted_25 = {
  class: "tools"
};
const _hoisted_26 = {
  class: "btn btn-publish"
};
const _hoisted_27 = ["onClick", "disabled"];
const _hoisted_28 = {
  key: 0,
  class: "iconfont icon-download"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = {
  key: 1,
  class: "right-error"
};
const _hoisted_31 = {
  class: "pagination"
};
const _hoisted_32 = ["src"];
import nodata from "@/assets/img/no-data.png";
import { onMounted, onUnmounted, reactive, ref } from "vue";
import { CircleCloseFilled } from "@element-plus/icons-vue";
import { httpDownload, httpPost, httpGet } from "@/utils/http";
import { checkSession, getClientId } from "@/store/cache";
import { closeLoading, showLoading, showMessageError, showMessageOK } from "@/utils/dialog";
import { replaceImg } from "@/utils/libs";
import { ElMessage, ElMessageBox } from "element-plus";
import BlackSwitch from "@/components/ui/BlackSwitch.vue";
import Generating from "@/components/ui/Generating.vue";
import BlackDialog from "@/components/ui/BlackDialog.vue";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'Luma',
  setup(__props) {
    const showDialog = ref(false);
    const currentVideoUrl = ref("");
    const row = ref(1);
    const images = ref([]);
    const formData = reactive({
      client_id: getClientId(),
      prompt: "",
      expand_prompt: false,
      loop: false,
      first_frame_img: "",
      end_frame_img: ""
    });
    const store = useSharedStore();
    onMounted(() => {
      checkSession().then(() => {
        fetchData(1);
      });
      store.addMessageHandler("luma", data => {
        // 丢弃无关消息
        if (data.channel !== "luma" || data.clientId !== getClientId()) {
          return;
        }
        if (data.body === "FINISH" || data.body === "FAIL") {
          fetchData(1);
        }
      });
    });
    onUnmounted(() => {
      store.removeMessageHandler("luma");
    });
    const download = item => {
      const url = replaceImg(item.video_url);
      const downloadURL = `${process.env.VUE_APP_API_HOST}/api/download?url=${url}`;
      // parse filename
      const urlObj = new URL(url);
      const fileName = urlObj.pathname.split("/").pop();
      item.downloading = true;
      httpDownload(downloadURL).then(response => {
        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        item.downloading = false;
      }).catch(() => {
        showMessageError("下载失败");
        item.downloading = false;
      });
    };
    const play = item => {
      currentVideoUrl.value = replaceImg(item.video_url);
      showDialog.value = true;
    };
    const removeJob = item => {
      ElMessageBox.confirm("此操作将会删除任务相关文件，继续操作码?", "删除提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        httpGet("/video/remove", {
          id: item.id
        }).then(() => {
          ElMessage.success("任务删除成功");
          fetchData();
        }).catch(e => {
          ElMessage.error("任务删除失败：" + e.message);
        });
      }).catch(() => {});
    };
    const publishJob = item => {
      httpGet("/video/publish", {
        id: item.id,
        publish: item.publish
      }).then(() => {
        ElMessage.success("操作成功");
      }).catch(e => {
        ElMessage.error("操作失败：" + e.message);
      });
    };
    const upload = file => {
      const formData = new FormData();
      formData.append("file", file.file, file.name);
      // 执行上传操作
      httpPost("/upload", formData).then(res => {
        images.value.push(res.data.url);
        ElMessage.success({
          message: "上传成功",
          duration: 500
        });
      }).catch(e => {
        ElMessage.error("图片上传失败:" + e.message);
      });
    };
    const remove = img => {
      images.value = images.value.filter(item => item !== img);
    };
    const switchReverse = () => {
      images.value = images.value.reverse();
    };
    const loading = ref(false);
    const list = ref([]);
    const noData = ref(true);
    const page = ref(1);
    const pageSize = ref(10);
    const total = ref(0);
    const fetchData = _page => {
      if (_page) {
        page.value = _page;
      }
      httpGet("/video/list", {
        page: page.value,
        page_size: pageSize.value,
        type: "luma"
      }).then(res => {
        total.value = res.data.total;
        loading.value = false;
        list.value = res.data.items;
        noData.value = list.value.length === 0;
      }).catch(() => {
        loading.value = false;
        noData.value = true;
      });
    };

    // 创建视频
    const create = () => {
      const len = images.value.length;
      if (len) {
        formData.first_frame_img = images.value[0];
        if (len === 2) {
          formData.end_frame_img = images.value[1];
        }
      }
      httpPost("/video/luma/create", formData).then(() => {
        fetchData(1);
        showMessageOK("创建任务成功");
      }).catch(e => {
        showMessageError("创建任务失败：" + e.message);
      });
    };
    const generatePrompt = () => {
      if (formData.prompt === "") {
        return showMessageError("请输入原始提示词");
      }
      showLoading("正在生成视频脚本...");
      httpPost("/prompt/video", {
        prompt: formData.prompt
      }).then(res => {
        formData.prompt = res.data;
        closeLoading();
      }).catch(e => {
        showMessageError("生成提示词失败：" + e.message);
        closeLoading();
      });
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_container = _resolveComponent("el-container");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (img, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: img
        }, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_image, {
          src: _unref(replaceImg)(img),
          fit: "cover"
        }, null, 8, ["src"]), _createVNode(_component_el_icon, {
          onClick: $event => remove(img)
        }, {
          default: _withCtx(() => [_createVNode(_unref(CircleCloseFilled))]),
          _: 2
        }, 1032, ["onClick"])]), images.value.length === 2 && index === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("i", {
          class: "iconfont icon-exchange",
          onClick: switchReverse
        })])) : _createCommentVNode("", true)], 64);
      }), 128))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [images.value.length < 2 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_upload, {
        class: "avatar-uploader",
        "auto-upload": true,
        "show-file-list": false,
        "http-request": upload,
        accept: ".jpg,.png,.jpeg"
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("i", {
          class: "iconfont icon-image"
        }, null, -1)])),
        _: 1
      })])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("textarea", {
        class: "prompt-input",
        rows: row.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.prompt = $event),
        placeholder: "请输入提示词或者上传图片",
        autofocus: ""
      }, " ", 8, _hoisted_9), [[_vModelText, formData.prompt]]), _createElementVNode("div", {
        class: "send-icon",
        onClick: create
      }, _cache[9] || (_cache[9] = [_createElementVNode("i", {
        class: "iconfont icon-send"
      }, null, -1)]))]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
        class: "generate-btn",
        size: "small",
        onClick: generatePrompt,
        color: "#5865f2"
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createElementVNode("i", {
          class: "iconfont icon-chuangzuo",
          style: {
            "margin-right": "5px"
          }
        }, null, -1), _createElementVNode("span", null, "生成AI视频提示词", -1)])),
        _: 1
      })]), _createElementVNode("div", _hoisted_12, [_cache[11] || (_cache[11] = _createElementVNode("span", {
        class: "label"
      }, "循环参考图", -1)), _createVNode(_component_el_switch, {
        modelValue: formData.loop,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.loop = $event),
        size: "small"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_13, [_cache[12] || (_cache[12] = _createElementVNode("span", {
        class: "label"
      }, "提示词优化", -1)), _createVNode(_component_el_switch, {
        modelValue: formData.expand_prompt,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.expand_prompt = $event),
        size: "small"
      }, null, 8, ["modelValue"])])])])]), _withDirectives((_openBlock(), _createBlock(_component_el_container, {
        class: "video-container",
        "element-loading-background": "rgba(100,100,100,0.3)"
      }, {
        default: _withCtx(() => [_cache[17] || (_cache[17] = _createElementVNode("h2", {
          class: "h-title text-2xl mb-5 mt-2"
        }, "你的作品", -1)), !noData.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.id
          }, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [item.progress === 100 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("video", {
            class: "video",
            src: _unref(replaceImg)(item.video_url),
            preload: "auto",
            loop: "loop",
            muted: "muted"
          }, "您的浏览器不支持视频播放", 8, _hoisted_19), _createElementVNode("button", {
            class: "play flex justify-center items-center",
            onClick: $event => play(item)
          }, _cache[13] || (_cache[13] = [_createElementVNode("img", {
            src: "/images/play.svg",
            alt: ""
          }, null, -1)]), 8, _hoisted_20)])) : item.progress > 100 ? (_openBlock(), _createBlock(_component_el_image, {
            key: 1,
            src: item.cover_url,
            fit: "cover"
          }, null, 8, ["src"])) : (_openBlock(), _createBlock(Generating, {
            key: 2,
            message: "正在生成视频"
          }))])]), _createElementVNode("div", _hoisted_21, [item.progress === 101 ? (_openBlock(), _createElementBlock("div", _hoisted_22, "任务执行失败：" + _toDisplayString(item.err_msg) + "，任务提示词：" + _toDisplayString(item.prompt), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(item.prompt), 1))]), item.progress === 100 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("button", _hoisted_26, [_cache[14] || (_cache[14] = _createElementVNode("span", {
            class: "text"
          }, "发布", -1)), _createVNode(BlackSwitch, {
            value: item.publish,
            "onUpdate:value": $event => item.publish = $event,
            onChange: $event => publishJob(item),
            size: "small"
          }, null, 8, ["value", "onUpdate:value", "onChange"])]), _createVNode(_component_el_tooltip, {
            content: "下载视频",
            placement: "top"
          }, {
            default: _withCtx(() => [_createElementVNode("button", {
              class: "btn btn-icon",
              onClick: $event => download(item),
              disabled: item.downloading
            }, [!item.downloading ? (_openBlock(), _createElementBlock("i", _hoisted_28)) : (_openBlock(), _createBlock(_component_el_image, {
              key: 1,
              src: "/images/loading.gif",
              class: "downloading",
              fit: "cover"
            }))], 8, _hoisted_27)]),
            _: 2
          }, 1024), _createVNode(_component_el_tooltip, {
            content: "删除",
            placement: "top"
          }, {
            default: _withCtx(() => [_createElementVNode("button", {
              class: "btn btn-icon",
              onClick: $event => removeJob(item)
            }, _cache[15] || (_cache[15] = [_createElementVNode("i", {
              class: "iconfont icon-remove"
            }, null, -1)]), 8, _hoisted_29)]),
            _: 2
          }, 1024)])])) : (_openBlock(), _createElementBlock("div", _hoisted_30, [_createVNode(_component_el_button, {
            type: "danger",
            onClick: $event => removeJob(item),
            circle: ""
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [_createElementVNode("i", {
              class: "iconfont icon-remove"
            }, null, -1)])),
            _: 2
          }, 1032, ["onClick"])]))])]);
        }), 128))])) : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          "image-size": 100,
          image: _unref(nodata),
          description: "没有任何作品，赶紧去创作吧！"
        }, null, 8, ["image"])), _createElementVNode("div", _hoisted_31, [total.value > pageSize.value ? (_openBlock(), _createBlock(_component_el_pagination, {
          key: 0,
          background: "",
          style: {
            "--el-pagination-button-bg-color": "rgba(86, 86, 95, 0.2)"
          },
          layout: "total,prev, pager, next",
          "hide-on-single-page": true,
          "current-page": page.value,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => page.value = $event),
          "page-size": pageSize.value,
          "onUpdate:pageSize": _cache[4] || (_cache[4] = $event => pageSize.value = $event),
          onCurrentChange: _cache[5] || (_cache[5] = $event => fetchData(page.value)),
          total: total.value
        }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])]),
        _: 1
      })), [[_directive_loading, loading.value]]), _createVNode(BlackDialog, {
        show: showDialog.value,
        "onUpdate:show": _cache[6] || (_cache[6] = $event => showDialog.value = $event),
        title: "预览视频",
        "hide-footer": "",
        onCancal: _cache[7] || (_cache[7] = $event => showDialog.value = false),
        width: "auto"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("video", {
          style: {
            "width": "100%",
            "max-height": "90vh"
          },
          src: currentVideoUrl.value,
          preload: "auto",
          autoplay: true,
          loop: "loop",
          muted: "muted"
        }, " 您的浏览器不支持视频播放 ", 8, _hoisted_32), [[_vShow, showDialog.value]])]),
        _: 1
      }, 8, ["show"])]);
    };
  }
};